"use client";

// FoldsSpent — the dashboard's word when the month's free folds are spent (lib/billing/meter, John 2026-10-29: "an
// explicit announcement to them in their email as well as on their dashboard").
//
// One line in the Noticer's voice, floating just above the bottom edge like the avatar nudge: what stopped, what
// never does, when it comes back, and the one door (the plan, where plus is). "later" lets it rest for this visit
// only; it is back on the next one for as long as the folds are spent, because it is true for as long as that.

import { useEffect, useState } from "react";
import { PLAN_PATH, resetDay, type FoldStanding } from "../../lib/billing/meter";
import "./folds-spent.css";

const REST_KEY = "in-folds-spent";

export default function FoldsSpent({ folds }: { folds: FoldStanding }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (sessionStorage.getItem(REST_KEY) === folds.month) return;
    } catch {
      /* private mode: show it */
    }
    const t = setTimeout(() => setShow(true), 1400);
    return () => clearTimeout(t);
  }, [folds.month]);

  const rest = () => {
    try {
      sessionStorage.setItem(REST_KEY, folds.month);
    } catch {
      /* fine */
    }
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fs-band" role="status">
      <p className="fs-band__line os-enter-soft">
        <span className="ink-dot" aria-hidden />
        this month&apos;s {(folds.cap ?? 0).toLocaleString("en-US")} folds are used, so your memory reads but takes nothing new until {resetDay(folds)}.{" "}
        <a className="quiet-link" href={PLAN_PATH}>
          move to plus
        </a>{" "}
        <span className="fs-band__sep" aria-hidden>
          ·
        </span>{" "}
        <button type="button" className="quiet-link fs-band__later" onClick={rest}>
          later
        </button>
      </p>
    </div>
  );
}
